/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

export interface BookshelfSortableState {
	sortMap(): Record<string, string>;
	getParams(): { sort?: string };
	changeSort(sort: string): void;
}

export interface BookshelfSortAttrs extends ComponentAttrs {
	state: BookshelfSortableState;
	prfx: string;
}

export default class BookshelfSort<CustomAttrs extends BookshelfSortAttrs = BookshelfSortAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { prfx } = this.attrs;

		return (
			<div className="BookshelfSort">
				<label className="BookshelfSort-label">{app.translator.trans(`${prfx}.label`)}</label>
				<SelectDropdown buttonClassName="Button Button--secondary" caretIcon="far fa-chevron-down">
					{this.options.toArray()}
				</SelectDropdown>
			</div>
		);
	}

	get options(): ItemList<Mithril.Children> {
		const { state, prfx } = this.attrs;

		const options = new ItemList<Mithril.Children>();
		const sortMap = state.sortMap();

		const sortOptions: Record<string, ReturnType<typeof app.translator.trans>> = {};
		for (const key in sortMap) {
			sortOptions[key] = app.translator.trans(`${prfx}.${key}_button`);
		}

		Object.keys(sortOptions).forEach((key) => {
			const label = sortOptions[key];
			const active = (state.getParams().sort || Object.keys(sortMap)[0]) === key;

			options.add(
				key,
				<Button active={active} icon={active ? 'fas fa-check' : true} onclick={state.changeSort.bind(state, key)}>
					{label}
				</Button>
			);
		});

		return options;
	}
}
